import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as SettingsActions } from 'store/ducks/settings';

import { Validate } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Configs/Settings/components';

class Edit extends Component {
  state = {
    data: {
      name: '',
      description: '',
      value: '',
    },

    errors: {},

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Configurações', to: '/configs' },
      { name: 'Variáveis', to: '/configs/settings' },
      { name: 'Detalhes', to: '' },
    ],
  };

  componentDidMount() {
    const { getSettingRequest } = this.props;

    getSettingRequest(this.handleGetId());
  }

  componentDidUpdate(oldProps) {
    const { setting } = this.props;

    if (oldProps.setting.loading && !setting.loading) {
      this.setState({
        data: {
          name: setting.data.attributes.name,
          description: setting.data.attributes.description,
          value: setting.data.attributes.value,
        },
      });
    }
  }

  handleGetId = () => {
    const match = matchPath(this.props.location.pathname, { path: '/configs/settings/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleValidate = () => {
    const { form } = this.state;

    const rules = {
      name: {
        required: true,
      },

      description: {
        required: true,
      },

      value: {
        required: true,
      },
    };

    const validate = Validate(form, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (!this.handleValidate()) return;

    const { form } = this.state;
    const { updateSettingRequest } = this.props;

    updateSettingRequest(this.handleGetId(), {
      conf: {
        value: form.value,
        description: form.description,
      },
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          saving={update.loading}
          errors={errors}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
      </Page>
    );
  }
}

const mapState = state => ({
  setting: state.settings.detail,
  update: state.settings.update,
});

const mapActions = dispatch => bindActionCreators(SettingsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
